import { useQuery } from '@tanstack/react-query'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery, useApi } from '@fortem-monorepo/react-spa'
import { MonthlyRoll } from '@fortem-monorepo/web-sdk'

import { getMonthlyRollOptions } from '@/react-query/queries/monthly-roll'

const colDefs = createColDefs([
  { field: 'fund_name', headerName: 'Fund' },
  { field: 'value_date', headerName: 'Date' },
  {
    field: 'proxy_nav',
    valueFormatter: numberFormatter({
      delimiter: true,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }),
    headerName: 'Soft Nav',
  },
  {
    field: 'pnl',
    valueFormatter: numberFormatter({
      delimiter: true,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }),
    headerName: 'P&L',
  },
  {
    field: 'tpo_perf',
    valueFormatter: numberFormatter({ transformer: (val) => val * 10_000 }),
    headerName: 'Perf (bps)',
  },
])

export interface MonthlyRollPerfTP1TableProps {
  params: MonthlyRoll.GetMonthlyRollParams
}

export const MonthlyRollPerfTP1Table: React.FC<MonthlyRollPerfTP1TableProps> = ({ params }) => {
  const api = useApi()
  const query = useQuery({
    ...getMonthlyRollOptions(api, params),
    enabled: false,
  })

  return (
    <Widget exposed className={'h-full'}>
      <WidgetHeaderWithQuery query={query} title="Performance T+1 - Fund Currency" />
      <WidgetContent loading={query?.isLoading}>
        <CustomAgGrid
          columnDefs={colDefs}
          rowData={query.data?.perf_tpo}
          domLayout={'normal'}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}
